import useSWR from "swr";
import { fetcher } from "./fetcher";
import usePriority from "./priority";

export const useHotTopicList = ({
    limit,
    isDetail,
    fallbackData,
}: {
    limit?: number;
    isDetail?: boolean;
    /** GSSP 초기 데이터 — 있으면 priority 대기 없이 첫 HTML부터 사용 */
    fallbackData?: any[] | null;
}) => {
    const priority = usePriority(1);
    const { data, isValidating } = useSWR(
        priority || isDetail || !!fallbackData ? `/api/hotTopic?limit=${limit}` : null,
        fetcher,
        {
            revalidateOnMount: true,
            revalidateOnFocus: false,
            ...(fallbackData ? { fallbackData } : {}),
        }
    );
    const isValid = !data && isValidating;
    return [data, isValid];
}